import { t } from '@/features/i18n/utils';
import { AdminOrganizationsList } from '@/features/admin-organizations/components/admin-organizations-list';
import { useAdminOrganizationsAccess } from '@/features/admin-organizations/helpers';
import { Breadcrumb, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderCopyButton, HeaderOrganizationMenu } from '@/ui/components/header';
import { AdminOrganizationsState } from '@/features/admin-organizations/components/admin-organizations-state';
import { Spinner } from '@/ui/components/spinner';
import { Building06Icon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_authed/settings/internal/organizations')({
  component: RouteComponent,
  validateSearch: z.object({
    highlightedOrganization: z.string().optional(),
  }),
});

function RouteComponent() {
  const { highlightedOrganization } = Route.useSearch();
  const access = useAdminOrganizationsAccess();

  return (
    <>
      <Header>
        <HeaderOrganizationMenu />
        <Breadcrumb>
          <BreadcrumbPage>
            <Icon icon={Building06Icon} />
            {t({ en: 'Organisation approvals', nb: 'Godkjenning av organisasjoner' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderCopyButton />
      </Header>
      {access.isLoading ? (
        <Spinner kind="inset" />
      ) : access.isError || !access.hasAccess ? (
        <AdminOrganizationsState
          forbidden={!access.isError && !access.hasAccess}
          pending={access.isFetching}
          onRetry={() => access.refetch()}
        />
      ) : (
        <AdminOrganizationsList highlightedOrganization={highlightedOrganization} />
      )}
    </>
  );
}
